import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
import { StickyCTA } from '../components/StickyCTA';
import { OrderBumpProvider } from '../hooks/useOrderBumps';
const ProblemSection = lazy(() => import('../components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const OpeningLead = lazy(() => import('../components/OpeningLead').then(m => ({
  default: m.OpeningLead
})));
const EditorialTips = lazy(() => import('../components/EditorialTips').then(m => ({
  default: m.EditorialTips
})));
const PdfPreview = lazy(() => import('../components/PdfPreview').then(m => ({
  default: m.PdfPreview
})));
const Testimonials = lazy(() => import('../components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const Bonuses = lazy(() => import('../components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Guarantee = lazy(() => import('../components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('../components/FAQ').then(m => ({
  default: m.FAQ
})));
const PriceComparison = lazy(() => import('../components/PriceComparison').then(m => ({
  default: m.PriceComparison
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofToast = lazy(() => import('../components/SocialProofToast').then(m => ({
  default: m.SocialProofToast
})));
const DiscountPopup = lazy(() => import('../components/DiscountPopup').then(m => ({
  default: m.DiscountPopup
})));
function SalesPageContent() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/20" data-id="element-845">
      <Hero data-id="element-846" />
      <Suspense fallback={<div className="min-h-[20vh]" data-id="element-848" />} data-id="element-847">
        <ProblemSection data-id="element-849" />
        <OpeningLead data-id="element-850" />
        <EditorialTips data-id="element-851" />
        <Testimonials data-id="element-852" />
        <PdfPreview data-id="element-853" />
        <WhatYouGet data-id="element-854" />
        <Bonuses data-id="element-855" />
        <PricingSection data-id="element-856" />
        <Guarantee data-id="element-857" />
        <FAQ data-id="element-858" />
        <PriceComparison data-id="element-859" />
        <Footer data-id="element-860" />
        <SocialProofToast data-id="element-861" />
        <DiscountPopup data-id="element-862" />
      </Suspense>
      <StickyCTA data-id="element-863" />
    </div>;
}
export function SalesPage() {
  return <OrderBumpProvider data-id="element-864">
      <SalesPageContent data-id="element-865" />
    </OrderBumpProvider>;
}